<script>
import { CloseOutlined } from '@ant-design/icons-vue'
import ScrollPane from './Scrollpane.vue'
import path from 'path'
import { onMounted } from '@vue/runtime-core'
import { computed, reactive, toRefs } from '@vue/reactivity'
import { ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'

export default {
  components: { ScrollPane, CloseOutlined },
  setup() {
    const route = useRoute()
    const router = useRouter()
    const store = useStore()

    const tag = ref([])
    const el = ref(null)

    const stateData = reactive({
      visible: false,
      top: 0,
      left: 0,
      selectedTag: {},
      affixTags: []
    })

    const visitedViews = computed(() => {
      return store.state.tagsView.visitedViews
    })

    const routes = computed(() => {
      return store.state.permission.routes
    })

    // ✅ 先定义 closeMenu，再在 watch 中使用
    const closeMenu = async () => {
      stateData.visible = false
    }

    // 现在可以安全地在 watch 中引用 closeMenu
    watch(
      () => stateData.visible,
      (value) => {
        if (value) {
          document.body.addEventListener('click', closeMenu)
        } else {
          document.body.removeEventListener('click', closeMenu)
        }
      },
      {
        immediate: true,
        deep: true
      }
    )

    const addTags = async () => {
      const { name } = route
      if (name) {
        store.dispatch('tagsView/addView', route)
      }
      return false
    }

    const moveToCurrentTag = async () => {
      const tags = tag.value
      for (const t of tags) {
        if (t.to.path === route.path) {
          if (t.to.fullPath !== route.fullPath) {
            store.dispatch('tagsView/updateVisitedView', route)
          }
          break
        }
      }
    }

    watch(
      () => route.path,
      () => {
        addTags()
        moveToCurrentTag()
      },
      {
        immediate: true,
        deep: true
      }
    )

    onMounted(async () => {
      initTags()
      addTags()
    })

    const isActive = (row) => {
      return route.path === row.path
    }

    const isAffix = (tag) => {
      return tag.meta && tag.meta.affix
    }

    const filterAffixTags = (routesA, basePath = '/') => {
      let tags = []
      routesA.forEach((route) => {
        if (route.meta && route.meta.affix) {
          const tagPath = path.resolve(basePath, route.path)
          tags.push({
            fullPath: tagPath,
            path: tagPath,
            name: route.name,
            meta: { ...route.meta }
          })
        }
        if (route.children) {
          const tempTags = filterAffixTags(route.children, route.path)
          if (tempTags.length >= 1) {
            tags = [...tags, ...tempTags]
          }
        }
      })
      return tags
    }

    const initTags = async () => {
      const affixTags = await filterAffixTags(routes.value)
      stateData.affixTags = affixTags
      for (const tag of affixTags) {
        if (tag.name) {
          store.dispatch('tagsView/addVisitedView', tag)
        }
      }
    }

    const closeSelectedTag = (view) => {
      store.dispatch('tagsView/delView', view).then(({ visitedViews }) => {
        if (isActive(view)) {
          toLastView(visitedViews, view)
        }
      })
    }

    const toLastView = (visitedViews, view) => {
      const latestView = visitedViews.slice(-1)[0]
      if (latestView) {
        router.push(latestView.fullPath)
      } else {
        if (view.name === 'Dashboard') {
          router.replace({ path: '/redirect' + view.fullPath })
        } else {
          router.push('/')
        }
      }
    }

    const openMenu = (view, e) => {
      const menuMinWidth = 105
      const offsetLeft = el.value?.getBoundingClientRect().left || 0
      const offsetWidth = el.value?.offsetWidth || 0
      const maxLeft = offsetWidth - menuMinWidth
      let left = e.clientX - offsetLeft + 15

      if (left > maxLeft) {
        stateData.left = maxLeft
      } else {
        stateData.left = left
      }

      stateData.top = e.clientY
      stateData.visible = true
      stateData.selectedTag = view // 注意：这里应该是 view，不是 tag
    }

    const handleScroll = () => {
      closeMenu()
    }

    return {
      ...toRefs(stateData),
      route,
      visitedViews,
      routes,
      addTags,
      isActive,
      closeSelectedTag,
      isAffix
    }
  }
}
</script>